import { CheckPermissionLayout } from "layouts";
import { RouteObject } from "react-router-dom";
import { PERMISSION } from "utils";
import { ROUTE } from "./constants";
import { lazy } from "react";

export const accessSmsRoutes : RouteObject[] = [
    {
        element: <CheckPermissionLayout permission={[PERMISSION.ACCESS_SMS]}/>,
        children: [
            {
                path: ROUTE.SMS,
                children: [
                    {
                        index: true,
                        Component: lazy(() => import('pages/SMS'))
                    }
                ]
            }
        ]
    }
]